import React, { memo, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { getCountdown } from "../helper/Countdown";
import { addToCart } from "../helper/cartfunction";
import useFetchApiData from "../helper/useFetchApiData";

const SampleNextArrow = memo((props) => {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-right" />
    </button>
  );
});

const SamplePrevArrow = memo((props) => {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-left" />
    </button>
  );
});

const HotDealsOne = () => {
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  const data = useFetchApiData("/flash-sale");
  console.warn("Flash sale",data)

  console.warn(data);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const calculateDiscountedPrice = (price, discount, discountType) => {
    if (discountType === "amount") {
      return price - discount;
    }
    if (discountType === "percent") {
      return price - (price * discount) / 100;
    }
    return price;
  };

  const calculateDiscountPercent = (price, discount, discountType) => {
    if (discountType === "percent") {
      return discount;
    }
    if (discountType === "amount") {
      return ((discount / price) * 100).toFixed(0);
    }
    return 0;
  };

  // Only render the section if `data.total_size` is greater than 0
  if (!data || data.total_size === 0) {
    return null; // Return null or empty if no data
  }

  return (
    <>
      <section className="hot-deals pt-80 mb-80">
        <div className="container container-lg">
          <div className="section-heading">
            <div className="flex-between flex-wrap gap-8">
              <h5 className="mb-0">{data?.flash_sale?.title}</h5>
            </div>
          </div>
          <div className="row g-12">
            <div className="col-md-4">
              <div className="hot-deals position-relative rounded-16 bg-main-600 overflow-hidden p-28 z-1 text-center">
                <img
                  src="assets/images/shape/offer-shape.png"
                  alt=""
                  className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                />
                <div className="hot-deals__thumb">
                  <img
                    src="https://img.freepik.com/free-vector/yellow-neon-flash-sale-sign_23-2149111858.jpg"
                    alt=""
                    style={{ width: "235px", height: "180px" }}
                  />
                </div>
                <br />
                <div className="py-xl-8">
                  <h4 className="text-white mb-8">{data?.flash_sale?.title}</h4>

                  <Link
                    to="/shop"
                    className="mt-16 btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
                    tabIndex={0}
                  >
                    Shop Now
                    <span className="icon text-xl d-flex">
                      <i className="ph ph-arrow-right" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="hot-deals-slider arrow-style-two">
                <Slider {...settings}>
                  {data?.products?.length > 1 &&
                    data.products.map((item) => (
                      <div key={item.id}>
                        <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                          <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                            Sale{" "}
                            {calculateDiscountPercent(
                              item.price,
                              item.discount,
                              item.discount_type
                            )}{" "}
                            %
                          </span>
                          <Link
                            to={`/product-details/${item.id}`}
                            className="product-card__thumb flex-center"
                          >
                            <img
                              src={item?.image_fullpath?.[0]}
                              alt={item.name}
                            />
                          </Link>
                          <div className="product-card__content p-sm-2">
                            <h6 className="title text-lg fw-semibold mt-12 mb-8">
                              <Link
                                to={`/product-details/${item.id}`}
                                className="link text-line-2"
                              >
                                {item.name}
                              </Link>
                            </h6>

                            <div className="product-card__content mt-12">
                              <div className="product-card__price mb-8">
                                <span className="text-heading text-md fw-semibold">
                                  Rs.
                                  {calculateDiscountedPrice(
                                    item.price,
                                    item.discount,
                                    item.discount_type
                                  )}
                                </span>
                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through ml-4">
                                  Rs.{item.price} {item.id}
                                </span>
                              </div>

                              <button
                                onClick={() => {
                                  addToCart(item.id, 1);
                                }}
                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                              >
                                Add To Cart{" "}
                                <i className="ph ph-shopping-cart" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HotDealsOne;
